/** Pure helpers for the fancy font generator preview: sample text, line handling and the accent note. */

export const SAMPLE_PHRASE = "Type something here";

/** Applies a style to each line on its own so line breaks survive (and Upside Down reverses within a line). */
export function convertLines(text: string, convertOne: (line: string) => string): string {
  return text.split(/\r?\n/).map((line) => (line === "" ? "" : convertOne(line))).join("\n");
}

/** True when the text holds an accent or other combining mark (precomposed é counts, since styling splits it into e + mark). */
export function hasCombiningMarks(text: string): boolean {
  return /[\u0300-\u036f]/.test(text.normalize("NFD"));
}

/** What the cards show: the typed text, or the sample phrase (greyed) while the box is empty. */
export function previewSource(input: string): { text: string; isSample: boolean } {
  return input.trim() === "" ? { text: SAMPLE_PHRASE, isSample: true } : { text: input, isSample: false };
}
